import { render } from "./SwitchVerticalIcon.vue?vue&type=template&id=91e2ca9e"
import script from "./SwitchVerticalIcon.vue?vue&type=script&lang=js"
export * from "./SwitchVerticalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__